import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const AccessoryFaq = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('accessory_notice'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 15, lineHeight: '22px' }}>{t('accessory_faq1')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('accessory_faq2')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('accessory_faq3')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('accessory_faq4')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('accessory_faq5')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('accessory_faq6')}</span>
            </div>
        </div>
    </div>
}

export default AccessoryFaq